import React, { useState, useEffect } from 'react';
import '../styles/asg-animations.css';

const useAsgAnimation = (animationClassDuration, dependencies) => {
    const [animationEnabled, setAnimationEnabled] = useState(true);

    // show animation on every dependency change
    useEffect(() => {
        setAnimationEnabled(true);
        const timer = setTimeout(() => {
            setAnimationEnabled(false);
        }, animationClassDuration);

        return () => {
            clearTimeout(timer);
        };
    }, dependencies);

    return animationEnabled;
};

/**
 * On every dependency change - adds fade-in animation
 */
export const useAsgFadeInAnimation = (
    animationClassDuration = 1000,
    dependencies = [],
) => {
    const animationEnabled = useAsgAnimation(animationClassDuration, dependencies);

    return {
        animationEnabled,
        animationClassName: 'asg-animated-item--fade-in',
    };
};

/**
 * Three dots animation (flashing)
 */
export const useAsg3DotsFlashing = () => {
    return {
        animationEnabled: true,
        animationClassName: 'asg-animated-item--3-dots-flashing',
    };
};

/**
 * The marquee animation
 * @link https://ryanmulligan.dev/blog/css-marquee/
 */
export const useAsgMarquee = ({
    contentToAnimate,
    gap,
    animationDurationSec = 20,
}) => {
    return {
        animatedContent: contentToAnimate
            ? (
                <div
                    className="asg-animated-item--marquee"
                    style={{
                        '--asg-marquee-gap': gap,
                        '--asg-marquee-animation-time': `${animationDurationSec}s`,
                    }}
                >
                    <div className="asg-animated-item--marquee__content">
                        {contentToAnimate}
                    </div>
                    <div aria-hidden="true" className="asg-animated-item--marquee__content">
                        {contentToAnimate}
                    </div>
                </div>
            )
            : null,
    };
};

/**
 * On every dependency change - adds vertical flip animation
 */
export const useAsgVerticalFlipAnimation = (
    animationClassDuration = 1000,
    dependencies = [],
) => {
    const animationEnabled = useAsgAnimation(animationClassDuration, dependencies);

    return {
        animationEnabled,
        animationClassName: 'asg-animated-item--vertical-flip',
    };
};
